/**
 * @param {CanvasRenderingContext2D} context
 * @param {number} width
 * @param {number} height
 * @param {number} margin
 */
export default function scaleCanvas(context, width, height, margin) {
  const devicePixelRatio = window.devicePixelRatio || 1;

  context.canvas.width = width * devicePixelRatio;
  context.canvas.height = height * devicePixelRatio;

  context.canvas.style.width = width + 'px';

  context.scale(devicePixelRatio, devicePixelRatio);
  context.translate(margin, margin);

  return { width: context.canvas.width, height: context.canvas.height };
}
